import { useCallback } from 'react';
import { Constants } from '../config/constants';
import { spruceContactSearchUrl } from '../logic/spruce';

export type SpruceCall = {
  onCall: () => void;
  /** Spruce is on but the phone is still loading: a click now would fall back to Twilio. */
  pending: boolean;
  /** Spruce will open (the org is set and the phone is a usable US number). */
  viaSpruce: boolean;
  /** Accessible name / tooltip for the button. */
  label: string;
};

// The Call button for every surface: Spruce's contact search in a new tab when Spruce is
// configured for this environment, otherwise the caller's existing Twilio flow.
export default function useSpruceCall(
  phone: string | null | undefined,
  loading: boolean,
  fallback: () => void,
): SpruceCall {
  const url = spruceContactSearchUrl(Constants.SPRUCE_ORG_ID, phone);
  const pending = !!Constants.SPRUCE_ORG_ID && loading;

  const onCall = useCallback(() => {
    if (pending) return;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }
    fallback();
  }, [pending, url, fallback]);

  let label = 'Call patient';
  if (pending) label = 'Loading patient…';
  else if (url) label = 'Call in Spruce (opens a new tab)';

  return {
    onCall, pending, viaSpruce: !!url, label,
  };
}
